import { Routes } from '../utils/Routes'
import { PaymentMethods } from '../../shared/utils/PaymentMethods'
import { webshopService } from '../../shared/services/WebshopService'

const thanksMixin = {
  methods: {
    checkLastOrderResponse () {
      if (!this.lastOrderResponse) {
        this.$router.replace(Routes.defaultPackageSelector())
        return false
      }

      if (this.lastOrderResponse.paymentMethod === PaymentMethods.OTP &&
          this.$route.name !== Routes.THANK_YOU_BANKCARD.name) {
        this.$router.replace(Routes.THANK_YOU_BANKCARD)
        return false
      }

      if (this.lastOrderResponse.paymentMethod === PaymentMethods.WIRE &&
        this.$route.name !== Routes.THANK_YOU_WIRE.name) {
        this.$router.replace(Routes.THANK_YOU_WIRE)
        return false
      }

      return true
    }
  },
  computed: {
    lastOrderResponse () {
      return this.$store.state.lastOrderResponse
    },

    paymentInfo () {
      return this.lastOrderResponse ? this.lastOrderResponse.payment : null
    },

    total () {
      return this.lastOrderResponse.invoice ? this.lastOrderResponse.invoice.grossAmount : null
    },

    orderId () {
      return this.lastOrderResponse ? this.lastOrderResponse.orderId : null
    },

    contractInfo () {
      return this.lastOrderResponse ? this.lastOrderResponse.contract : null
    },

    contractUrl () {
      if (!this.contractInfo) return null
      return webshopService.getContractUrl({ ...this.contractInfo })
    }
  }
}

export default thanksMixin
